export function setupBuscador() {
  //buscador
  const icono_buscar = document.querySelectorAll(".icono_buscar");
  for (const item of icono_buscar) {
    item.addEventListener("click", function (e) {
      document.querySelector(".header").classList.toggle("buscador_abierto");

      //   document.querySelector(".preheader").classList.toggle("buscador_abierto");

      setTimeout(function () {
        const p = e.target.parentElement;
        // p.querySelector(".buscador--buscador_form input").focus();
      }, 350);
    });
    const buscador_form_cerrar = document.querySelector(
      ".buscador_form_cerrar"
    );
    if (buscador_form_cerrar)
      buscador_form_cerrar.addEventListener("click", function () {
        document.querySelector(".header").classList.remove("buscador_abierto");
      });
  }

  const field_buscar = document.querySelector(".menu_mobile .buscador input");
  if (field_buscar) {
    field_buscar.addEventListener("focus", function (e) {
      document.querySelector(".menu_mobile").classList.add("buscador_abierto");
    });
    field_buscar.addEventListener("blur", function (e) {
      document
        .querySelector(".menu_mobile")
        .classList.remove("buscador_abierto");
    });
  }
}

const $btn = document.querySelector(".icono_buscar");
const $input = document.querySelector(".input_buscador");
$btn.addEventListener("click", () => {
  $input.classList.toggle("input_buscador_activo");
  $input.focus();
});
